import { Translation } from '@shared/types/translation';

export const AUTH_OTP_ERROR_MESSAGES = {
  INVALID_OTP: { english: 'Incorrect OTP', polish: 'Niepoprawny kod' },
} as const satisfies Record<string, Translation>;
